var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatarForum = function SvgDefaultAvatarForum(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M67.984 36.817a4.671 4.671 0 0 1-5.838-.243L36.362 13.908 10.191 36.611a4.654 4.654 0 0 1-6.33-.216 4.573 4.573 0 0 1 .196-6.693l29.69-26.208a3.955 3.955 0 0 1 5.26.015l29.315 26.187a4.582 4.582 0 0 1 .156 6.703l-.435.418h-.06zm-56.61.265l-.01-.053c-.229-1.195 1.044-3.09 2.03-3.927l20.931-18.091a3.137 3.137 0 0 1 4.096-.003l20.927 17.934c1.007.87 2.26 2.734 2.023 3.987l-5.048 22.254a6.379 6.379 0 0 1-6.281 5.164H22.703c-3.057.01-5.692-2.15-6.275-5.105l-5.054-22.16z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatarForum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar--forum.2d25ad1447b051020b62356b06a916f6.svg";